import { useEffect } from 'react';
import { db } from '../db/indexedDb';

export function useThemeBootstrap() {
  useEffect(() => {
    void (async () => {
      const settings = await db.getAppSettings();
      document.documentElement.classList.toggle('light', settings.theme === 'light');
      document.documentElement.classList.toggle('dark', settings.theme !== 'light');
    })();
  }, []);
}
